import { Pipe, PipeTransform } from '@angular/core';
import { Airport } from '@store/origins/types';

@Pipe({
  name: 'dotCountryOrState',
})

// Get the state name (if U.S.) or country name of an airport
export class DotCountryOrStatePipe implements PipeTransform {
  transform(airport: Airport, enabled = true): string {
    if (enabled) {
      return airport.countryCode === 'US'
        ? this.airportCodeToStateName(airport.code)
        : this.countryCodeToName(airport.countryCode);
    }
    return null;
  }

  private airportCodeToStateName(code: string): string {
    const stateCodeToNameMap: { [key: string]: string } = {
      TVC: 'Michigan',
      RAP: 'South Dakota',
      JAX: 'Florida',
      HNL: 'Hawaii',
      STL: 'Missouri',
      XNA: 'Arkansas',
      SDF: 'Kentucky',
      PNS: 'Florida',
      DFW: 'Texas',
      OMA: 'Nebraska',
      EYW: 'Florida',
      MIA: 'Florida',
      MYR: 'South Carolina',
      LGA: 'New York',
      JST: 'Pennsylvania',
      IAD: 'District of Columbia',
      SEA: 'Washington',
      HOU: 'Texas',
      IAH: 'Texas',
      CVG: 'Ohio',
      RSW: 'Florida',
      UIN: 'Illinois',
      BTV: 'Vermont',
      FLL: 'Florida',
      HPN: 'New York',
      BDL: 'Connecticut',
      ABQ: 'New Mexico',
      BUF: 'New York',
      ONT: 'California',
      SFO: 'California',
      BUR: 'California',
      RDU: 'North Carolina',
      SWF: 'New York',
      MKE: 'Wisconsin',
      ACK: 'Massachusetts',
      LIH: 'Hawaii',
      MKK: 'Hawaii',
      RUT: 'Vermont',
      LIT: 'Arkansas',
      ATL: 'Georgia',
      BFI: 'Washington',
      ITO: 'Hawaii',
      CHO: 'Virginia',
      SHD: 'Virginia',
      JFK: 'New York',
      CHS: 'South Carolina',
      AUG: 'Maine',
      BWI: 'Maryland',
      PBI: 'Florida',
      AUS: 'Texas',
      MMH: 'California',
      HSV: 'Alabama',
      BGR: 'Maine',
      PSP: 'California',
      SYR: 'New York',
      AVL: 'North Carolina',
      OAK: 'California',
      BHB: 'Maine',
      ORD: 'Illinois',
      ORF: 'Virginia',
      ORH: 'Massachusetts',
      SJC: 'California',
      TLH: 'Florida',
      HDN: 'Colorado',
      GSO: 'North Carolina',
      PDX: 'Oregon',
      RIC: 'Virginia',
      RIL: 'Colorado',
      BZN: 'Montana',
      BJC: 'Colorado',
      PVC: 'Massachusetts',
      CLE: 'Ohio',
      PVD: 'Rhode Island',
      CLT: 'North Carolina',
      SLC: 'Utah',
      SLK: 'New York',
      GUC: 'Colorado',
      LNY: 'Hawaii',
      CMH: 'Ohio',
      FCA: 'Montana',
      PWM: 'Maine',
      RKD: 'Maine',
      SMF: 'California',
      TPA: 'Florida',
      SNA: 'California',
      HHH: 'South Carolina',
      HYA: 'Massachusetts',
      PHL: 'Pennsylvania',
      MRY: 'California',
      MBL: 'Michigan',
      OWB: 'Kentucky',
      KOA: 'Hawaii',
      PHX: 'Arizona',
      DAB: 'Florida',
      MSP: 'Minnesota',
      OGG: 'Hawaii',
      DAL: 'Texas',
      MSY: 'Louisiana',
      MCI: 'Missouri',
      ECP: 'Florida',
      BNA: 'Tennessee',
      ALB: 'New York',
      MCO: 'Florida',
      PIT: 'Pennsylvania',
      OGS: 'New York',
      DAY: 'Ohio',
      LAS: 'Nevada',
      MTJ: 'Colorado',
      LAX: 'California',
      ILM: 'North Carolina',
      RNO: 'Nevada',
      DSI: 'Florida',
      MDT: 'Pennsylvania',
      BOI: 'Idaho',
      DCA: 'District of Columbia',
      ROA: 'Virginia',
      CAE: 'South Carolina',
      ROC: 'New York',
      BOS: 'Massachusetts',
      TSM: 'New Mexico',
      MEM: 'Tennessee',
      IND: 'Indiana',
      SAN: 'California',
      SAR: 'Illinois',
      DTW: 'Michigan',
      SAT: 'Texas',
      SAV: 'Georgia',
      MVY: 'Massachusetts',
      EWB: 'Massachusetts',
      SRQ: 'Florida',
      MWA: 'Illinois',
      DUJ: 'Pennsylvania',
      SBN: 'Indiana',
      EWR: 'New Jersey',
      EGE: 'Colorado',
      DEC: 'Illinois',
      LEB: 'New Hampshire',
      TUL: 'Oklahoma',
      DEN: 'Colorado',
      JAC: 'Wyoming',
      CCR: 'California',
      MGW: 'West Virginia',
      BRL: 'Iowa',
    };
    return stateCodeToNameMap[code] || '';
  }

  // Data retrieved and transformed from /od/od-service/countries endpoint
  private countryCodeToName(code: string): string {
    const countryCodeToNameMap: { [key: string]: string } = {
      AF: 'Afghanistan',
      AL: 'Albania',
      DZ: 'Algeria',
      AS: 'American Samoa',
      AO: 'Angola',
      AI: 'Anguilla',
      AG: 'Antigua and Barbuda',
      AR: 'Argentina',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaijan',
      BS: 'Bahamas',
      BH: 'Bahrain',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'Belgium',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BO: 'Bolivia',
      BA: 'Bosnia and Herzegovina',
      BW: 'Botswana',
      BR: 'Brazil',
      VG: 'British Virgin Islands',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodia',
      CM: 'Cameroon',
      CA: 'Canada',
      CV: 'Cape Verde',
      KY: 'Cayman Islands',
      CL: 'Chile',
      CN: 'China',
      CO: 'Colombia',
      CG: 'Congo',
      CD: 'Congo, Democratic Republic',
      CR: 'Costa Rica',
      CI: 'Cote Divoire',
      HR: 'Croatia',
      CU: 'Cuba',
      CW: 'Curacao',
      CY: 'Cyprus',
      CZ: 'Czech Republic',
      DK: 'Denmark',
      DM: 'Dominica',
      DO: 'Dominican Republic',
      EC: 'Ecuador',
      EG: 'Egypt',
      SV: 'El Salvador',
      GQ: 'Equatorial Guinea',
      ER: 'Eritrea',
      EE: 'Estonia',
      ET: 'Ethiopia',
      FK: 'Falkland Islands (Malvinas)',
      FI: 'Finland',
      FR: 'France',
      PF: 'French Polynesia',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Germany',
      GH: 'Ghana',
      GR: 'Greece',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GT: 'Guatemala',
      GN: 'Guinea',
      GY: 'Guyana',
      HT: 'Haiti',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Hungary',
      IS: 'Iceland',
      IN: 'India',
      ID: 'Indonesia',
      IR: 'Iran',
      IQ: 'Iraq',
      IE: 'Ireland',
      IL: 'Israel',
      IT: 'Italy',
      JM: 'Jamaica',
      JP: 'Japan',
      JO: 'Jordan',
      KZ: 'Kazakstan',
      KE: 'Kenya',
      KW: 'Kuwait',
      LV: 'Latvia',
      LB: 'Lebanon',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libyan Arab Jamahiriya',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malaysia',
      MV: 'Maldives',
      MT: 'Malta',
      MQ: 'Martinique',
      MU: 'Mauritius',
      MX: 'Mexico',
      MD: 'Moldova',
      MA: 'Morocco',
      MZ: 'Mozambique',
      NA: 'Namibia',
      NL: 'Netherlands',
      NZ: 'New Zealand',
      NI: 'Nicaragua',
      NG: 'Nigeria',
      NO: 'Norway',
      OM: 'Oman',
      PK: 'Pakistan',
      PA: 'Panama',
      PE: 'Peru',
      PH: 'Philippines',
      PL: 'Poland',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Qatar',
      RO: 'Romania',
      RU: 'Russian Federation',
      RW: 'Rwanda',
      KN: 'Saint Kitts and Nevis',
      LC: 'Saint Lucia',
      SX: 'Saint Maarten',
      VC: 'Saint Vincent and the Grenadines',
      SA: 'Saudi Arabia',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      ZA: 'South Africa',
      KR: 'South Korea',
      ES: 'Spain',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SZ: 'Swaziland',
      SE: 'Sweden',
      CH: 'Switzerland',
      TZ: 'Tanzania',
      TH: 'Thailand',
      TG: 'Togo',
      TT: 'Trinidad and Tobago',
      TN: 'Tunisia',
      TR: 'Turkey',
      TM: 'Turkmenistan',
      TC: 'Turks and Caicos islands',
      VI: 'U.S. Virgin Islands',
      UG: 'Uganda',
      UA: 'Ukraine',
      AE: 'United Arab Emirates',
      GB: 'United Kingdom',
      US: 'United States',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VE: 'Venezuela',
      VN: 'Vietnam',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
    };
    return countryCodeToNameMap[code] || '';
  }
}
